module.exports = __webpack_public_path__ + "img/img_tanhua.4700bf0a.png";